import { createSlice } from "@reduxjs/toolkit";

const BlogSlice = createSlice({
    name: "blog",
    initialState: {
        blogs: []
    },
    reducers: {
        blogData: (state, action) => {
            const { heading, content, imagePath } = action.payload;
            state.blogs.push({
                heading,
                content,
                image: imagePath,
            });
        }
    },
});

export const { blogData } = BlogSlice.actions;
export default BlogSlice.reducer;